import { useState } from 'react';
import axios from 'axios';
import { useMsal } from 'src/auth/firebaseMsalCompat';

import { loginRequest } from '../../config/authConfig';
import { getApiHost } from '../../utils/getApiHost';
import type { Hand } from '../../types/types';

/**
 * Answers the single-part hand dialog. ``selectHand`` spends the credit and
 * dispatches generation. Failures are returned to the caller (not the error
 * boundary) so the project page stays usable.
 */
export const useHandSelection = () => {
  const { instance } = useMsal();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const authHeaders = async () => {
    const authResult = await instance.acquireTokenSilent({ ...loginRequest });
    return { Authorization: `Bearer ${authResult.idToken}` };
  };

  const post = async (path: string, body: object) => {
    setIsSubmitting(true);
    try {
      const headers = await authHeaders();
      await axios.post(`${getApiHost()}${path}`, body, { headers });
    } finally {
      setIsSubmitting(false);
    }
  };

  const selectHand = (projectId: string, hand: Hand) =>
    post(`/fingering/select-hand/${projectId}`, { hand });

  const reportInstrument = (projectId: string, instrument: string) =>
    post(`/fingering/report-instrument/${projectId}`, { instrument });

  return { selectHand, reportInstrument, isSubmitting };
};
